<template>
  <div>
    <div class="footer">
      <div class="footer_cont">
        <div class="footer_cont_top">
          <div class="footer_left" v-if="ci === '130400'">
            <h4>指导单位</h4>
            <h3>邯郸市数据局</h3>
            <h3>邯郸市行政审批局</h3>
            <h3>邯郸市公共资源交易中心</h3>
            <p>整合全市工程建设、政府采购、土地及产权交易活动的统一电子化交易平台。</p>
          </div>
          <div class="footer_left" v-else-if="ci === '130700'">
            <h3>张家口市数政局</h3>
            <h3>张家口市公共资源交易中心</h3>
          </div>
          <div class="foot" v-else>
            <span>
              <h2>加盟合作：</h2>
              <ul>
                <a v-for="(item, index) in url" :key="index" :href="item.href" target="_bank">
                  <li>{{ item.name }}</li>
                </a>
              </ul>
            </span>
            <span style="margin-left: 62px">
              <h2>友情链接：</h2>
              <ul>
                <a v-for="(item, index) in friendshipUrl" :key="index" :href="item.href" target="_bank">
                  <li>{{ item.name }}</li>
                </a>
              </ul>
            </span>
          </div>
          <div class="footTwo">
            <p class="footTwo_tel">400-690-6108</p>
            <p class="footTwo_time" style="margin-top: 5px">
              服务热线:(上午09:00-12:00--下午13:00-18:30)
            </p>
            <div class="center_kefu" @click="goKefu">
              <div class="kefuBtn">
                <a href="">
                  <p class="kefu">
                    <!-- <span class="btn_img">
                      <img src="../assets/images/qq.png" alt=""
                    /></span> -->
                    咨询在线客服
                  </p>
                </a>
              </div>
            </div>
          </div>
          <div class="footer_right" v-if="ci === '130400'">
            <h4>运营单位</h4>
            <h3>邯郸市数据集团有限公司</h3>
            <p>作为邯郸市数据要素市场化配置的核心平台，致力于运营数据要素、服务城市发展。</p>
          </div>
          <div class="footer_right" v-else-if="ci === '130700'">
            <h3>张家口数字产业发展集团有限公司</h3>
          </div>
          <div class="footThree" v-else>
            <div>
              <span class="footThree_codeOne">
                <img src="../assets/images/codeOne.png" alt="" />
                <!-- <img :src="poster" alt="" /> -->
              </span>
              <p>微信扫码关注<br />云采金服订阅号</p>
            </div>
            <div style="margin-left: 20px">
              <span class="footThree_codeTwo">
                <img src="../assets/images/codeTwo.png" alt="" />
                <!-- <img :src="poster" alt="" /> -->
              </span>
              <p>微信扫码关注<br />云采金服科技服务号</p>
            </div>
          </div>
        </div>
        <div class="footer_cont_bottom">
          <div class="bot_p">
            <p>
              Copyright©2017-{{ year }}, cyc-fund.com. All rights reserved. |
              ICP证：<span @click="goICP">京ICP备19016327号</span> 建议使用浏览器：360浏览器
            </p>
          </div>
        </div>
      </div>
      <div class="footer_show">
        <div class="footer_show_bottom">
          <img class="imgOne" src="../assets/images/china.png" alt="" />
          <img class="imgTwo" src="../assets/images/education.png" alt="" />
          <img class="imgThree" src="../assets/images/security.png" alt="" />
          <img class="imgFour" src="../assets/images/Zhongguancun.png" alt="" />
          <img class="imgFive" src="../assets/images/tech.png" alt="" />
          <img class="imgSix" src="../assets/images/police.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footers",
  props: {
    imgSrc: {
      type: Array,
      defaulut() {
        return [];
      },
    },
    poster: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      host: '',
      url: [],
      friendshipUrl: [
        { name: '丽水市公共资源交易中心', href: 'https://lssggzy.lishui.gov.cn/' },
        { name: '杭州市公共资源交易中心', href: 'https://ggzy.hzctc.hangzhou.gov.cn/Index/Home' },
        { name: '宁波市公共资源交易中心', href: 'http://www.nbggzy.cn/' },
        { name: '济南市公共资源交易中心', href: 'http://jnggzy.jinan.gov.cn/' }
      ],
      ci: this.$cookies.get("ci"),
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
  mounted() {
    this.host = process.env.VUE_APP_BID_URL
    this.url = [
      { name: '企业合作', href: `${this.host}/Enterprise` },
      { name: '地方政府合作', href: `${this.host}/Local` },
      { name: '金融机构合作', href: `${this.host}/Finance` },
    ]
  },
  methods: {
    goKefu() {
      window.open('https://www.cyc-fund.com.cn/userChat/goUserChat.do')
    },
    goICP() {
      window.open('https://beian.miit.gov.cn/')
    }
  }
};
</script>


<style scoped lang="less">
.footer {
  width: 100%;
  margin-top: 50px;
}

.footer_cont {
  width: 100%;
  /* height: 297px; */
  background-color: #363c41;
}

.footer_cont_top {
  width: 1212px;
  /* height: 231px; */
  margin: 0 auto;
  background-color: #363c41;
}

.footer_cont_bottom {
  width: 100%;
  height: 65px;
  border-top: 1px solid #666;
  background-color: #363c41;
  margin-top: 24px;
}

.foot li {
  margin-top: 8px;
  line-height: 14px;
}

.bot_p {
  width: 1212px;
  height: 100%;
  margin: 0 auto;
  background-color: #363c41;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer_cont_bottom p {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #a0a1a1;
}

/*  */

.footer_show {
  width: 100%;
  /* height: 50px; */
}

.footer_show_bottom {
  width: 100%;
  display: flex;
  justify-content: center;
}

.footer_show_bottom {
  width: 1212px;
  margin: 0 auto;
  margin-top: 6px;
}

.imgOne,
.imgTwo,
.imgThree,
.imgFour,
.imgFive,
.imgSix {
  height: 66px;
}

.imgOne {
  width: 378px;
}

.imgTwo {
  width: 215px;
}

.imgThree {
  width: 167px;
}

.imgFour {
  width: 183px;
}

.imgFive {
  width: 136px;
}

.imgSix {
  width: 167px;
}

.footer_cont_top {
  display: flex;
  justify-content: space-between;
}

.foot {
  display: flex;
  justify-content: space-between;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #d6d8d9;
  /* line-height: 14px; */
}

.foot,
.footThree {
  margin-top: 60px;
  text-align: center;
}

.footTwo {
  margin-top: 80px;
}

.footThree p {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
}

.foot h2 {
  font-size: 16px;
  color: #d6d8d9;
}

.foot a {
  color: #d6d8d9;
}

.footTwo {
  text-align: center;
}

.footThree {
  display: flex;
  justify-content: space-between;
}

.footThree_codeOne {
  display: inline-block;
  width: 119px;
  height: 118px;
}

.footThree_codeOne img {
  width: 100%;
  height: 100%;
}

.footThree_codeTwo {
  display: inline-block;
  width: 119px;
  height: 118px;
}

.footThree_codeTwo img {
  width: 100%;
  height: 100%;
}

.footTwo_tel {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #a0a1a1;
  margin: 0;
}

.footTwo_time {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #a0a1a1;
}

.kefuBtn {
  width: 140px;
  height: 32px;
  background: #fd5f39;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.kefu {
  margin: 0;
  display: inline-block;
  width: 140px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}

.btn_img {
  display: inline-block;
  width: 16px;
  height: 18px;
  position: absolute;
  left: 0%;
  top: 50%;
  transform: translate(0%, -50%);
}

.btn_img img {
  width: 100%;
  height: 100%;
}

.center_kefu {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.footer_left {
  float: left;
  width: 300px;
  margin-top: 80px;

  h4 {
    color: #e5e7eb;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  h3 {
    color: #fff;
    font-size: 16px;
    margin-bottom: 10px;
  }

  p {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #A0A1A1;
  }
}

.footer_right {
  float: left;
  width: 300px;
  margin-top: 80px;

  h4 {
    color: #e5e7eb;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  h3 {
    color: #fff;
    font-size: 16px;
    margin-bottom: 10px;
  }

  p {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #A0A1A1;
  }
}
</style>
